<mat-card class="example-card">
  <mat-card-header>
    <div mat-card-avatar class="example-header-image"></div>
    <mat-card-title>{{ getTitle() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      {{ notificationMessage }}
    </p>
  </mat-card-content>
  <mat-card-actions>
    <button (click)="close()" mat-button>{{ "Close" | localize }}</button>
  </mat-card-actions>
</mat-card>
